<dx-data-grid
  #grid
  height="100%"
  [dataSource]="statistiques"
  keyExpr="id"
  noDataText="Pas de données"
  showBorders="true"
  showRowLines="true"
  allowColumnResizing="true"
  rowAlternationEnabled="true"
  columnResizingMode="widget"
  (onSelectionChanged)="onSelectLine($event)"
  (onToolbarPreparing)="onToolbarPreparing($event)">

  <div *dxTemplate=" let cell of 'beforeTemplate'">
    <yo-button
      [theme]="ButtonThemeEnum.DEFAULT"
      iconClass="fas fa-chart-bar"
      label="Générer des statistiques"
      (onClick)="openDialogGeneration()"
      tooltip="Génerer des statistiques EGAlim">
    </yo-button>
  </div>

  <div *dxTemplate="let cell of 'afterTemplate'">
    <div class="custom-button-container">
      <yo-button
        [theme]="getConnectionButtonTheme()"
        iconClass="fas fa-wifi"
        (onClick)="openMaCantineConnectionDialog()"
        tooltip="Ouvrir le panneau de connexion à 'Ma Cantine'">
      </yo-button>
      <yo-button
        [theme]="ButtonThemeEnum.DEFAULT"
        [disabled]="!maCantineConnection?.isConnected || !(selectedRows?.length > 0)"
        iconClass="fas fa-stethoscope"
        (onClick)="sendDiagnostics()"
        tooltip="Ouvrir le panneau de connexion à 'Ma Cantine'">
      </yo-button>
      <yo-button
        [theme]="ButtonThemeEnum.DEFAULT"
        [disabled]="!(selectedRows?.length > 0)"
        iconClass="fas fa-download"
        (onClick)="exportDiagnostics()"
        tooltip="Exporter sous forme de diagnostique 'Ma Cantine'">
      </yo-button>
      <yo-button
        [theme]="ButtonThemeEnum.DEFAULT"
        [disabled]="!(selectedRows?.length > 0)"
        iconClass="fa fa-envelope"
        (onClick)="sendMail()"
        tooltip="Envoyer par mail les fichiers excel des diagnostiques">
      </yo-button>
    </div>
  </div>

  <dxo-selection
    selectAllMode="allPages"
    showCheckBoxesMode="always"
    mode="multiple">
  </dxo-selection>

  <dxo-column-chooser mode="select" [enabled]="true"></dxo-column-chooser>
  <dxo-sorting mode="multiple"></dxo-sorting>
  <dxo-group-panel [visible]="true"></dxo-group-panel>
  <dxo-grouping [autoExpandAll]="true"></dxo-grouping>
  <dxo-header-filter [visible]="true"></dxo-header-filter>

  <dxi-column
    caption="Action"
    width="5%"
    cellTemplate="actionTemplate">
  </dxi-column>
  <dxi-column *ngIf="isAtLeastOneMail()"
              caption="Emails"
              width="5%"
              cellTemplate="mailTemplate">
  </dxi-column>
  <dxi-column
    caption="Site"
    alignment="left"
    dataField="site.libelle"
    cellTemplate="siteTemplate">
  </dxi-column>
  <dxi-column
    caption="SIRET"
    width="10%"
    dataField="pointTeledeclaration.siret">
  </dxi-column>
  <dxi-column
    caption="Point de télédéclaration"
    dataField="pointTeledeclaration.libelle">
  </dxi-column>
  <dxi-column
    caption="Diagnostic"
    width="7%"
    dataField="isDiagnosticSent"
    alignment="left"
    cellTemplate="diagnosticTemplate">
  </dxi-column>
  <dxi-column
    caption="Année"
    width="6%"
    alignment="left"
    dataField="annee"
    cellTemplate="anneeTemplate">
  </dxi-column>
  <dxi-column
    caption="Conformité"
    width="7%"
    dataField="isConfome"
    alignment="left"
    cellTemplate="conformiteTemplate">
  </dxi-column>
  <dxi-column
    caption="Date de génération"
    width="11%"
    dataField="dateGeneration"
    dataType="date"
    format="dd/MM/yy HH:mm:ss"
    sortOrder="desc">
  </dxi-column>

  <dxo-pager
    [showPageSizeSelector]="true"
    [showNavigationButtons]="false"
    [allowedPageSizes]="[20, 50, 100, 200]"
    [visible]="true"
    [showInfo]="true"
    infoText="{2} statistique(s)">
  </dxo-pager>

  <div *dxTemplate="let cell of 'actionTemplate'">
    <div class="custom-button-container">
      <yo-button
        [theme]="ButtonThemeEnum.DEFAULT_INNER"
        tooltip="Ouvrir le détail du diagnostic"
        size="small"
        iconClass="fas fa-magnifying-glass-chart"
        (onClick)="openDiagnosticDialog(cell.data)">
      </yo-button>
      <yo-button
        [theme]="ButtonThemeEnum.DEFAULT_INNER"
        tooltip="Ouvrir le détail de conformité"
        size="small"
        iconClass="fas fa-search-location"
        (onClick)="openConformiteDialog(cell.data)">
      </yo-button>
    </div>
  </div>

  <div *dxTemplate="let cell of 'mailTemplate'">
    <div class="custom-button-container">
      <yo-email-histo-button
        [context]="EmailContextEnum.STATISTIQUE_EGALIM"
        [entityId]="cell.data.id"
        [emailHisto]="getLastEmail(cell.data?.emailHisto)"
        (onMailHistoRetrieve)="onMailHistoRetrieved($event, cell.data.id)">
      </yo-email-histo-button>
    </div>
  </div>

  <div *dxTemplate="let cell of 'siteTemplate'">
    <yo-site
      [siteId]="cell.data.site.id"
      [siteLibelle]="cell.data.site.libelle">
    </yo-site>
  </div>

  <div *dxTemplate="let cell of 'diagnosticTemplate'">
    <div class="custom-button-container">
      <yo-icon
        [theme]="getDiagnosticTheme(cell.data)"
        [icon]="getDiagnosticIcon(cell.data)"
        [title]="getDiagnosticTitle(cell.data)"
        size="large"
        variant="regular">
      </yo-icon>
    </div>
  </div>

  <div *dxTemplate="let cell of 'anneeTemplate'">
    <div class="custom-button-container">
      {{ cell.data.annee }}
    </div>
  </div>

  <div *dxTemplate="let cell of 'conformiteTemplate'">
    <div class="custom-button-container">
      <yo-icon
        [theme]="getConformiteTheme(cell.data.isConforme)"
        [icon]="getConformiteIcon(cell.data.isConforme)"
        [title]="getConformiteTitle(cell.data.isConforme)"
        size="large"
        variant="regular">
      </yo-icon>
    </div>
  </div>

</dx-data-grid>

<yo-dialog-histo-mails></yo-dialog-histo-mails>
<yo-statistiques-egalim-creation-dialog></yo-statistiques-egalim-creation-dialog>
<yo-statistiques-egalim-details-dialog></yo-statistiques-egalim-details-dialog>
<yo-ma-cantine-connection-dialog></yo-ma-cantine-connection-dialog>
<yo-statistiques-egalim-error-dialog></yo-statistiques-egalim-error-dialog>
<yo-statistiques-egalim-conformite-dialog></yo-statistiques-egalim-conformite-dialog>
